import React , {PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import { H3 } from '../text';
import styles from './error.styles';

export class Error extends PureComponent {

  constructor (props){
    super(props);
  }

  render(){
    const {i18n: {messages} } = this.props; 
    return (<View style={styles.root}>
      <H3>{messages['app.auth.logoutExpireSuccess.text']}</H3>
    </View>);
  } 
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true
    }
  }
})(Error);
